import React from 'react';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  className?: string;
  label?: string;
  disabled?: boolean;
  showPreview?: boolean;
  resetColor?: string;
  onReset?: () => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
  className = '',
  label,
  disabled = false,
  showPreview = true,
  resetColor,
  onReset,
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && (
        <label className="mr-2 font-medium text-sm" htmlFor="color-picker-input">
          {label}
        </label>
      )}
      <input
        id="color-picker-input"
        type="color"
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        className="w-8 h-8 p-0 border-none cursor-pointer"
        aria-label={label || 'Color picker'}
      />
      {showPreview && (
        <div
          className="w-6 h-6 rounded border"
          style={{ backgroundColor: value, borderColor: '#ccc' }}
          aria-label="color preview"
        />
      )}
      {resetColor && onReset && value !== resetColor && (
        <button
          type="button"
          className="ml-2 text-xs px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
          onClick={onReset}
          disabled={disabled}
        >
          Reset
        </button>
      )}
    </div>
  );
};

export default ColorPicker;
